const PopUp = () => {

    $(".mobile-overlay").click(function(){
        $(".pop-up").addClass("pop-up__open");
    });

    $(".pop-up__close-desktop").click(function(){
        $(".pop-up").addClass("pop-up__closed");
    });

    $(".pop-up__close-mobile").click(function(){
        $(".pop-up").removeClass("pop-up__open");
    });
    
}

export default PopUp;


// WEBPACK FOOTER //
// ./src/js/app/components/PopUp-box.js